import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section id="quote-section" className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-3 font-heading">Devis en 30 secondes</h2>
          <p className="text-sm md:text-base text-brand-text/60 mb-2">
            Appelez-nous ou demandez un devis en ligne. Réponse en moins de 15 minutes.
          </p>
          <p className="text-sm font-semibold text-brand-accent">
            Devis gratuit et sans engagement — Intervention 24/48h
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="w-full bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-mint/60">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <div className="space-y-4">
                  <div>
                    <p className="text-sm font-medium text-brand-dark mb-3">Comment préférez-vous nous contacter ?</p>
                    <div className="flex flex-col gap-3">
                      <Link
                        to="/devis-fenetre-paris-15/"
                        className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-brand-gradientFrom to-brand-gradientTo hover:opacity-90 text-white font-bold text-sm md:text-base px-6 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-brand-accent/20"
                      >
                        <i className="ri-file-text-line text-lg"></i>
                        Demander un devis en ligne
                      </Link>
                      <a
                        href="tel:+33187668155"
                        className="inline-flex items-center justify-center gap-2 bg-white hover:bg-brand-mint text-brand-dark font-bold text-sm md:text-base px-6 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer border border-brand-accent/30"
                      >
                        <i className="ri-phone-fill text-brand-accent text-lg"></i>
                        01 87 66 81 55
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-64 flex flex-col justify-center gap-4 p-6 bg-brand-mint/60 rounded-xl border border-brand-mint/60">
                <p className="text-sm font-semibold text-brand-dark font-heading">Vous préférez appeler ?</p>
                <a href="tel:+33187668155" className="inline-flex items-center gap-2 text-brand-accent hover:opacity-90 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-fill text-lg"></i>
                  01 87 66 81 55
                </a>
                <p className="text-xs text-brand-text/50">Réponse immédiate</p>
                <div className="border-t border-brand-mint my-1"></div>
                <a
                  href="https://wa.me/+33745883392?text=Bonjour%20DF%20PRO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#1faa52] font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-lg"></i>
                  WhatsApp
                </a>
                <p className="text-xs text-brand-text/50">On répond instantanément</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}